import { render } from "./Trash.svg?vue&type=template&id=a1fb13e2"
const script = {}
script.render = render

export default script